import React, { useCallback } from 'react';
import Modal, { ModalContent, ModalTitle } from '../../../../ui/Layout/Modals/Modal/Modal';
import { SongSimple } from '@round/api';
import { createTrndsClientSongFromSpotifyUrl } from '@round/api';
import ClientSongFromSpotifyForm, {
    ClientSongFromSpotifyFormProps,
} from '../../components/ClientSongFromSpotifyForm/ClientSongFromSpotifyForm';

type CreateClientSongModalProps = {
    clientId: number;
    isModalOpen: boolean;
    closeModal: () => void;
    onCreated: (song: SongSimple) => void;
};

const CreateClientSongModal = ({ clientId, isModalOpen, onCreated, closeModal }: CreateClientSongModalProps) => {
    const handleSubmit: ClientSongFromSpotifyFormProps['handleSubmit'] = useCallback(
        async (values, { setSubmitting, setErrors }) => {
            try {
                setSubmitting(true);

                const response = await createTrndsClientSongFromSpotifyUrl({ url: values.url, clientId });
                if (response.status === 400) {
                    setErrors({ url: response.data.error });
                    return;
                }

                onCreated(response.data);
                return;
            } catch {
                setErrors({ url: 'Sorry, some error occurred' });
            } finally {
                setSubmitting(false);
            }
        },
        [onCreated, clientId]
    );

    return (
        <Modal closeOnOverlayClick isOpen={isModalOpen} onClose={closeModal}>
            <ModalTitle>Add song</ModalTitle>
            <ModalContent>
                <ClientSongFromSpotifyForm handleSubmit={handleSubmit} />
            </ModalContent>
        </Modal>
    );
};

export default CreateClientSongModal;
